import type {
  SourceReaderFunction,
  TranslationRegistry,
} from '@festina-life/core'
import { useCallback } from 'react'
import { useIntl } from 'react-intl'

import { useLocalStorageShouldTranslate } from './useLocalStorageShouldTranslate'

const noOpTranslate: SourceReaderFunction<TranslationRegistry> = (
  key,
  ...placeholders
) => {
  const formattedPlaceholders =
    placeholders.length > 0
      ? placeholders.map((placeholder) =>
          Object.entries(placeholder)
            .map(([key, value]) => `(${key}:${value})`)
            .join(','),
        )
      : null

  return [key, ...(formattedPlaceholders ?? [])].join(' ')
}

export function useTranslate(): SourceReaderFunction<TranslationRegistry> {
  const intl = useIntl()
  const { shouldTranslateTexts } = useLocalStorageShouldTranslate()

  const translate: SourceReaderFunction<TranslationRegistry> = useCallback(
    (key, ...placeholders) =>
      intl.formatMessage({ id: key.toString() }, placeholders[0] ?? {}),
    [intl],
  )

  return shouldTranslateTexts ? translate : noOpTranslate
}
